function SliderSeo() {
	const swiper = new Swiper('.js-slider-seo .swiper-container', {
		// Optional parameters
		loop: true,
		spaceBetween: 25,
		slidesPerView: 1,
		observeParents: true,
		autoHeight: true,

		// If we need pagination
		pagination: {
			el: '.js-slider-seo .swiper-pagination',
			clickable: true,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.js-slider-seo-button-next',
			prevEl: '.js-slider-seo-button-prev',
		},

		breakpoints: {
			768: {
				allowTouchMove: false,
			},
			// when window width is >= 1200px
			1200: {
				autoHeight: false,
			},
		}
	});
}

function SetStickySliderSeo() {
	let offset = document.documentElement.scrollTop + 200;
	let heading = $('.js-section-slider-seo-heading')
	if (heading.length) {
		let headingOffset = $(heading).offset().top;

		if (offset >= headingOffset) {
			$(heading).addClass('is-sticky')
		} else {
			$(heading).removeClass('is-sticky')
		}

		let windowHeight = $(window).height();
		let control = $(".js-slider-seo .js-swiper-pagination")

		let offsetControl = .25;
		if (windowHeight >= 1080) {
			offsetControl = .5;
		} else if (windowHeight >= 1300) {
			offsetControl = .65
		}

		if (offset >= headingOffset - (windowHeight * offsetControl)) {
			$(control).fadeIn()
		} else {
			$(control).fadeOut(100)
		}
	}

}

function TestAnchorMenu() {
	if ($(".js-anchor-menu").length) {
		$('.js-section-slider-seo-heading').addClass('anchor-has');
	}
}

function InitStickySliderSeo() {
	SetStickySliderSeo();

	let ThrottlesStickySliderSeo = _.throttle(function () {
		SetStickySliderSeo();
	}, 100);

	$(window).scroll(function () {
		ThrottlesStickySliderSeo();
	})

	let scrollPos = 0;
	$(window).scroll(function () {
		let newScrollPos = $(this).scrollTop();
		TestAnchorMenu();
		if (newScrollPos > scrollPos) {
			$('.js-section-slider-seo-heading').addClass('is-up');
		} else {
			$('.js-section-slider-seo-heading').removeClass('is-up');
		}
		scrollPos = newScrollPos;
	});
}

export {
	SliderSeo,
	InitStickySliderSeo
};
